import { render, staticRenderFns } from "./MgmtShopAuth.vue?vue&type=template&id=1b086c39&"
import script from "./MgmtShopAuth.vue?vue&type=script&lang=js&"
export * from "./MgmtShopAuth.vue?vue&type=script&lang=js&"
import style0 from "./MgmtShopAuth.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports